export default "__VITE_ASSET__444e36f1__"